import { render, staticRenderFns } from "./auditTables.vue?vue&type=template&id=552f8a7a"
import script from "./auditTables.vue?vue&type=script&lang=js"
export * from "./auditTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('552f8a7a')) {
      api.createRecord('552f8a7a', component.options)
    } else {
      api.reload('552f8a7a', component.options)
    }
    module.hot.accept("./auditTables.vue?vue&type=template&id=552f8a7a", function () {
      api.rerender('552f8a7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/pca/plan/auditTables.vue"
export default component.exports